import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider } from 'react-router-dom'

import VotersPage from './Pages/VotersPage.js'
import CandidatesPage from './Pages/CandidatesPage.js'
import EmptyStatePage from "./Pages/EmptyStatePage";
import SignUpPage from './Pages/auth/SignUpPage.js'
import SigninPage from "./Pages/auth/SignIn";
import Elections from "./Components/Elections";
import { ClerkProvider } from '@clerk/clerk-react'
import RegisterElectionPage from './Pages/RegisterElectionPage.js'
import VoterRegistration from './Pages/VoterRegistration.js'
import CompanyProfilePage from './Pages/CompanyProfilePage.js';
import SettingsPage from './Pages/SettingsPage.js';
import RegisterCandidatePage from './Pages/RegisterCandidatePage.js'
import BallotSheetPage from "./Pages/BallotSheetPage";
import VoterVerifiedPage from "./Pages/VoterVerifiedPage";
import VoterScan from "./Pages/VoterScan";
import LogInPage from "./Pages/LogInPage.js";
import VotingStatisticsUpdated from "./Pages/VotingStatisticsUpdated";
import LandingPage from "./Pages/LandingPage";
import QRScanPage from "./Pages/QRScanPage";
import AdminDashboard from "./Pages/AdminDashboard";
import ProtectedRoute from "./Components/ProtectedRoute";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if(!PUBLISHABLE_KEY){
  throw new Error("Missing publishable key")
}

const router = createBrowserRouter([
  {
   children:[
    {
      path:'/',
      element:<App/>
    },
    {
      path:'/SettingsPage',
      element:<ProtectedRoute><SettingsPage/></ProtectedRoute>
    },
    {
       path:'/VoterVerifiedPage',
       element:<VoterVerifiedPage/>
    },
    {
       path:'/VoterScan',
       element:<VoterScan/>
    },
    {
       path: '/Elections',
       element: <ProtectedRoute><Elections/></ProtectedRoute>
    },
    {
       path: '/LandingPage',
       element: <LandingPage/>
    },
    {
        path:'/AdminDashboard',
       element: <ProtectedRoute><AdminDashboard/></ProtectedRoute>
    },
    {
      path:'/Voters',
      element:<ProtectedRoute><VotersPage/></ProtectedRoute>
    },
    {
      path:'/VoterRegistration',
      element:<ProtectedRoute><VoterRegistration/></ProtectedRoute>
    },
    {
      path:'/LogInPage',
      element:<LogInPage/>
    },
    {
      path:'/CandidatesPage',
      element:<ProtectedRoute><CandidatesPage/></ProtectedRoute>
    },
    {
      path:'/QRScanPage',
      element:<QRScanPage/>
    },
    {
      path:'/RegisterCandidatePage',
      element:<ProtectedRoute><RegisterCandidatePage/></ProtectedRoute>
    },
    {
      path: '/VotingStatisticsUpdated',
      element: <ProtectedRoute><VotingStatisticsUpdated/></ProtectedRoute>
    },
    {
      path:'/EmptyStatePage',
      element:<EmptyStatePage/>
    },
    {
      path:'/RegisterElectionPage',
      element:<ProtectedRoute><RegisterElectionPage/></ProtectedRoute>
    },
    {
      path:'/CompanyProfilePage',
      element:<ProtectedRoute><CompanyProfilePage/></ProtectedRoute>
    },
    {
      path:'/Candidates',
      element:<ProtectedRoute><CandidatesPage/></ProtectedRoute>
    }
   ]
  },
    {
        path:'/SignIn',
        element:<SigninPage/>
    },
  {
    path:'/SignUpPage',
    element:<SignUpPage/>
  },
    {
        path:'/BallotSheetPage',
        element:<BallotSheetPage/>
    },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <RouterProvider router={router}/>
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
